angular.module('LeasePilot').filter('toLetter', function() {
  return function(input) {
    if (!input) return null;
    return String.fromCharCode(97 + input - 1).toUpperCase();
  };
});
